type ReviewerProfile = {
  resource_access?: Record<string, { roles?: string[] }>;
};

export type InstructorAccessMode = 'staff' | 'reviewer' | 'denied';

/**
 * Browser affordance only; the API remains authoritative. Match the server's
 * narrow reviewer rule: one configured Hauraki client, an explicit reviewer
 * role, and an enabled kill switch. Never scan unrelated OAuth clients.
 */
export function hasExactReviewerAccess(
  profile: ReviewerProfile,
  clientId = process.env.REACT_APP_ZEWSTID_CLIENT_ID || '',
  killSwitch = process.env.REACT_APP_HAURAKI_REVIEWER_ALL_ACCESS,
): boolean {
  if (
    !clientId
    || killSwitch?.trim().toLowerCase() === 'off'
  ) {
    return false;
  }
  return profile.resource_access?.[clientId]?.roles?.includes('reviewer')
    === true;
}

/**
 * Admission ignores generic `profile.role` entirely. Only roles under the
 * configured instructor-dashboard client can admit an identity, and an exact
 * reviewer role always selects the isolated read-only surface.
 */
export function resolveInstructorAccess(
  profile: ReviewerProfile,
  clientId = process.env.REACT_APP_ZEWSTID_CLIENT_ID || '',
  killSwitch = process.env.REACT_APP_HAURAKI_REVIEWER_ALL_ACCESS,
): InstructorAccessMode {
  if (hasExactReviewerAccess(profile, clientId, killSwitch)) {
    return 'reviewer';
  }
  if (!clientId) return 'denied';
  const roles = profile.resource_access?.[clientId]?.roles ?? [];
  if (roles.includes('admin') || roles.includes('instructor')) {
    return 'staff';
  }
  return 'denied';
}
